import { Pipe } from "@angular/core";

@Pipe({ name: "suffix" })
export class SuffixPipe {
    transform(valor: any, sufixo: string): string {
        if (!valor || (valor.length && valor.length <= 0)) {
            return "";
        }

        return `${valor}${sufixo}`;
    }
}
